// Receives phone numbers dialed through the OS-level tel: handler the
// manifest registers on install. Two delivery paths: a fresh navigation
// lands with ?tel= in the URL, and an already-running installed window
// gets a launchQueue event (manifest launch_handler: focus-existing).
// Numbers are buffered until the app registers a handler, mirroring the
// desktop preload's pendingPhoneNumber.

const parseTelParam = (raw) => {
  if (!raw) return null;
  let value = raw;
  try {
    value = decodeURIComponent(raw);
  } catch {
    // keep raw value
  }
  const number = value.replace(/^tel:/i, '').replace(/[^0-9*#]/g, '');
  return number || null;
};

let pendingNumber = null;
let telHandler = null;

const deliver = (number) => {
  if (!number) return;
  if (telHandler) telHandler(number);
  else pendingNumber = number;
};

export const initTelLaunch = () => {
  const url = new URL(window.location.href);
  const tel = url.searchParams.get('tel');
  if (tel) {
    deliver(parseTelParam(tel));
    url.searchParams.delete('tel');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  if ('launchQueue' in window) {
    window.launchQueue.setConsumer((launchParams) => {
      if (!launchParams.targetURL) return;
      const target = new URL(launchParams.targetURL);
      deliver(parseTelParam(target.searchParams.get('tel')));
    });
  }
};

export const onTelProtocol = (callback) => {
  telHandler = callback;
  if (pendingNumber) {
    const number = pendingNumber;
    pendingNumber = null;
    callback(number);
  }
};

export const removeTelProtocol = () => {
  telHandler = null;
};
